/* tslint:disable */
/* eslint-disable */
export enum UpgradeFinalStatus {
  Success = 'SUCCESS',
  Failed = 'FAILED',
  HandledByCustomerCare = 'HANDLED_BY_CUSTOMER_CARE',
  InProgress = 'IN_PROGRESS',
  PaymentInProgress = 'PAYMENT_IN_PROGRESS',
  PaymentDone = 'PAYMENT_DONE',
  Initialized = 'INITIALIZED',
  PaymentInitialized = 'PAYMENT_INITIALIZED',
  PaymentFailed = 'PAYMENT_FAILED'
}
